import { FunctionComponent } from "react";
import { useSelector } from "react-redux";

import { useTranslation } from "react-i18next";

import {
  HomePageBannerContainer,
  HeroV2HomePageBannerContainer,
  InfoContainerV2,
  BannerTitle,
  BannerSubTitle,
} from "./styles";

import Carousel from "./Carousel";

import { getPartnerImageUrl } from "utils/getImageUrl";
import { configState } from "state/config-slice";
import breakpoints from "themes/default/breakpoints";

import FeatureWrapper from "components/FeatureToggle/FeatureWrapper";
import getOpco from "utils/getOpco";

const HomePageBanner: FunctionComponent = () => {
  const { cdnUrl } = useSelector(configState);
  const { t } = useTranslation();
  const opco = getOpco();

  return (
    <>
      <FeatureWrapper name="Default Banner">
        <HomePageBannerContainer>
          <source
            media={`(min-width:${breakpoints.values.lg}px)`}
            srcSet={getPartnerImageUrl("generic/banner-desktop.webp", cdnUrl)}
            width="1440"
            height="254"
          />
          <source
            media={`(min-width:${breakpoints.values.md}px)`}
            srcSet={getPartnerImageUrl("generic/banner-tablet.webp", cdnUrl)}
            width="744"
            height="218"
          />
          <img
            src={getPartnerImageUrl("generic/banner-mobile.webp", cdnUrl)}
            alt="homepage-overview"
            width="375"
            height="218"
          />
        </HomePageBannerContainer>
      </FeatureWrapper>
      <FeatureWrapper name="New Hero Banner">
        <Carousel />
      </FeatureWrapper>
      <FeatureWrapper name="New Hero Banner V2">
        <HeroV2HomePageBannerContainer background={getPartnerImageUrl("generic/banner", cdnUrl)}>
          <InfoContainerV2>
            {opco !== "lw" ? <BannerSubTitle>{t("Vodafone Subscription+")}</BannerSubTitle> : null}
            {opco !== "lw" ? <BannerTitle>{t("Everything you love, in one place.")}</BannerTitle> : null}
          </InfoContainerV2>
        </HeroV2HomePageBannerContainer>
      </FeatureWrapper>
    </>
  );
};

export default HomePageBanner;
